<script lang="ts">
    import { _ } from "svelte-i18n"
    import { checkoutData, getAsyncCartSum, setCartItemQuantity } from "../../../functionTools/cart"
    import { firstProductImage } from "../../../utils"
    import { login } from "../../../functionTools/login"
    import { formatPriceCurrency, langField } from "../../../i18n"
    import { getCountry, postCartUpdateEvent } from "../../../api"
    import QuantityCounter from "../product/detailed/QuantityCounter.svelte"
    import Lasersheets from "../product/widgets/lasersheet/Lasersheets.svelte"
    import CartItemUserInputs from "./CartItemUserInputs.svelte"
    import CartItemImage from "./CartItemImage.svelte"

    interface Props {
        cartItems: CartItem[]
    }

    let { cartItems }: Props = $props()

    let cartSum: CartSum = $state()

    $effect(() => {
        ;(async () => {
            cartSum = await getAsyncCartSum(cartItems)
        })()
    })
</script>

<div class="list">
    {#key cartItems}
        {#each cartItems as cartItem}
            <div class="product" class:invalid={$login && cartItem.product.no_dealers} data-testid="cart-item">
                <CartItemImage item={cartItem} />
                <div class="text">
                    <div class="title">
                        {langField(cartItem.product?.name, "")}
                    </div>
                    <div class="artnum" data-testid="cart-item-artnum">
                        {$_("cart.item-number-short")}
                        {cartItem.product?.code}
                    </div>
                    <CartItemUserInputs {cartItem} />

                    <div class="buttons">
                        <QuantityCounter
                            quantity={cartItem.quantity}
                            product={cartItem.product}
                            callback={(quantity) => {
                                setCartItemQuantity(cartItem, quantity)
                            }}
                        />
                        <button type="button" class="button secondary" onclick={() => setCartItemQuantity(cartItem, 0)}
                            >{$_("cart.remove")}</button
                        >
                    </div>
                </div>
                <div class="price">
                    {$formatPriceCurrency(cartItem.price.unit, $login ? 0 : $checkoutData.vat, cartItem.quantity)}
                </div>
            </div>
        {/each}
    {/key}
</div>

<style lang="less">
    @import "../../../css/variables.less";
    .product {
        &.invalid {
            filter: drop-shadow(2px 4px 6px darkred);
        }

        border-bottom: dotted 1px #ccc;
        .flex();
        justify-content: center;
        flex-wrap: wrap;
        margin-bottom: 20px;
        padding-bottom: 20px;

        .text {
            width: 60%;
            .title {
                font-size: 1.2rem;
                font-weight: 700;
            }
            .artnum {
                font-size: 0.7rem;
            }
        }
        .price {
            text-align: right;
            width: 40%;
            font-size: 1rem;
        }
        flex-wrap: nowrap;
        @media @max-mobile {
            display: grid;
            grid-template-columns: 3fr 1fr;
            width: 100%;

            .text {
                order: 2;
                width: 100%;
            }
            .price {
                order: 3;
                width: 100%;
            }
        }
        .buttons {
            min-width: 140px;
            width: 100%;
            margin-top: 20px;
            .flex();
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 1rem;

            .button {
                font-size: 0.8rem;
                .flex();
                max-width: 150px;
                align-items: center;
                justify-content: center;
                &:nth-child(2) {
                    @media (max-width: 1100px) {
                        margin-right: 0;
                    }
                }
                &:last-child {
                    padding: 5px 15px;
                    margin-right: 0;
                    @media (max-width: 1100px) {
                        width: 100%;
                        text-align: center;
                        margin-top: 10px;
                    }
                    @media (max-width: 550px) {
                        width: auto;
                        margin-top: 0px;
                    }
                    @media (max-width: 420px) {
                        width: 100%;
                        margin-top: 10px;
                    }
                }
            }
        }
    }
</style>
